const SELECTED_ACCOUNT_STORAGE_KEY = 'surelinc.cmmc.client.selectedAccountId';
const AWS_ACCOUNT_ID_PATTERN = /^\d{12}$/;

export function normalizeSelectedAccountId(value: unknown): string | null {
  const accountId = String(value ?? '').trim();
  return AWS_ACCOUNT_ID_PATTERN.test(accountId) ? accountId : null;
}

export function getSelectedAccountId(): string | null {
  try {
    return normalizeSelectedAccountId(window.sessionStorage.getItem(SELECTED_ACCOUNT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function setSelectedAccountId(value: string): string {
  const accountId = normalizeSelectedAccountId(value);
  if (!accountId) {
    throw new Error('AWS account ID must contain exactly 12 digits.');
  }
  window.sessionStorage.setItem(SELECTED_ACCOUNT_STORAGE_KEY, accountId);
  return accountId;
}

export function clearSelectedAccountId(): void {
  try {
    window.sessionStorage.removeItem(SELECTED_ACCOUNT_STORAGE_KEY);
  } catch {
    // Storage cleanup is best effort. Backend authorization remains authoritative.
  }
}
